module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/inicio/inicio.component.css
// module id = ./src/app/inicio/inicio.component.css
// module chunks = main